import { useField, useFormikContext } from 'formik'

import AssignedItemsButton from 'components/AssignedItemsButton'

const Categories = ({ setFormStep, showValidationErrors }) => {
  const handleReportingCategoriesClick = () => {
    setFormStep('reportingCategoriesDrawer')
  }

  const handleClickDisplayCategories = () =>
    setFormStep('displayCategoriesDrawer')

  const [field, meta] = useField('reportingCategoryUuid')
  const { values } = useFormikContext()

  const isError = showValidationErrors && meta.error

  return (
    <div className="content-wrapper -block">
      <h3 className="header-title">Categories</h3>
      <div
        className="content-wrapper -flags-wrapper"
        data-cy="display-categories-button"
      >
        <AssignedItemsButton
          handleClick={handleClickDisplayCategories}
          label="Display Categories"
          assignedItems={
            values?.displayCategoriesAssignedToItem?.length ?? 0
          }
        />
      </div>
      <div
        className="content-wrapper -flags-wrapper"
        data-cy="reporting-categories-button"
      >
        <AssignedItemsButton
          required
          handleClick={handleReportingCategoriesClick}
          label="Reporting Categories"
          assignedItems={field?.value?.length ?? 0}
          error={isError}
        />
      </div>
    </div>
  )
}
export default Categories
